module.exports = __webpack_public_path__ + "img/gongzichaxun.d315cff8.png";